import { Injectable, inject } from '@angular/core';
import { ITask } from 'shared';

import { TaskService } from '../task.service';
import { BaseSocketEventHandler } from './base-socket-event-handler';

interface TaskCreatedSocketEvent {
    eventDtoType: 'TaskCreated';
    task: ITask;
}

@Injectable({ providedIn: 'root' })
export class TaskCreatedSocketEventHandler extends BaseSocketEventHandler<TaskCreatedSocketEvent> {
    private taskService = inject(TaskService);

    protected eventDtoType(): string {
        return 'TaskCreated';
    }

    protected handleEvent = async (event: TaskCreatedSocketEvent): Promise<void> => {
        this.taskService.localUpdate(event.task);
    };
}
